import(/* webpackMode: "eager" */ "/workspace/src/app/crashclient/error.tsx");
